// extracted by mini-css-extract-plugin
export var screen = "screenTemplate-module--screen--MbnOS";
export var item = "screenTemplate-module--item--148cS";
export var shakeMemoji = "screenTemplate-module--shakeMemoji--1Bmzx";
export var starSolo = "screenTemplate-module--starSolo--2z8DM";